import { on } from 'js/lib/events'
import { initFlashCounter } from './lib'

on('click', '.js-c-flash__close', event => {
  const $flash = $(event.target).parents('.js-c-flash')

  $flash.fadeOut(() => {
    $flash.remove()
  })
})

$(document).ready(() => {
  const $countdown = $('.js-c-flash__countdown')

  if ($countdown.length === 0) return

  initFlashCounter($countdown)
})
